import React from "react";
import { Box, Typography } from "@mui/material";
import { css } from "aphrodite";
import styles from "./styles";
import { useTranslation } from "react-i18next";
import i18n from "../../../../i18n";
import { AccessibleLink } from "../AccessibleLink";

const CustomFooter = ({ webView = true }) => {
    const { t } = useTranslation(["translation"]);
    const currentYear = new Date().getFullYear();
    const isGreek = i18n.language === "gr";

    const links = {
        personalData: isGreek
            ? "https://www.bankofgreece.gr/xristika/proswpika-dedomena-xrhstwn-e-appointments-tte"
            : "https://www.bankofgreece.gr/en/useful-links/privacy-policy-e-appointments-bog",
        termsOfUse: isGreek
            ? "https://www.bankofgreece.gr/xristika/oroi-xrhshs-xrhstwn-e-appointments-tte"
            : "https://www.bankofgreece.gr/en/useful-links/term-of-use-e-appointments-bog",
        contact: isGreek
            ? "https://www.bankofgreece.gr/xristika/forma-epikoinwnias?subject=142"
            : "https://www.bankofgreece.gr/en/useful-links/contact-form?subject=143",
    };

    return (
        <Box
            component="footer"
            className={css(
                webView ? styles.footerContainer : styles.footerContainerMobile
            )}
        >
            <div className={css(styles.content)}>
                <Typography
                    variant="body2"
                    className={css(webView ? styles.text : styles.textMobile)}
                >
                    {t("Copyright").replace("{{year}}", currentYear)}
                </Typography>
                <div
                    className={css(
                        webView
                            ? styles.linksContainer
                            : styles.linksContainerMobile
                    )}
                >
                    <AccessibleLink
                        href={links.personalData}
                        className={css(
                            webView ? styles.link : styles.linkMobile
                        )}
                        external
                    >
                        {t("Personal Data")}
                    </AccessibleLink>
                    <div className={css(styles.linkDivider)} />
                    <AccessibleLink
                        href={links.termsOfUse}
                        className={css(
                            webView ? styles.link : styles.linkMobile
                        )}
                        external
                    >
                        {t("Terms of Use")}
                    </AccessibleLink>
                    <div className={css(styles.linkDivider)} />
                    <AccessibleLink
                        href={links.contact}
                        className={css(
                            webView ? styles.link : styles.linkMobile
                        )}
                        external
                    >
                        {t("Contact")}
                    </AccessibleLink>
                </div>
            </div>
        </Box>
    );
};

export default CustomFooter;
